import { redirect } from 'react-router';

export const AuthCallbackLoader = () => {
    const params = new URLSearchParams(window.location.search);
    const state = params.get('state') || '';

    let path = '/';
    if (state && sessionStorage) {
        const storedPath = sessionStorage.getItem(state);
        if (storedPath) {
            path = storedPath;
            sessionStorage.removeItem(state);
        }
    }

    return redirect(path);
};
